<template>
  <div id="wrapper" class="page">
    <meeting-side-bar index="2" />
    <div id="content-wrapper">
      <div id="shooting_schedule_fulid" class="container-fluid">
        <!-- <div class="mydiv">
          <b-form inline>
            <i class="fas fa-filter" id="popover-target-1"></i>
            <div style="flex-grow: 1" class="text-center">
              SHOOTING CALENDAR
            </div>
          </b-form>
        </div> -->
        <div class="mydiv">
          <b-row class="">
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.previous()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-left"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-left"
                style="background-color: #fde3c1; margin-left:3px;"
                id="popover-target-1"
              >
                <i
                  class="fas fa-filter"
                  style="font-size: 22px !important; padding: 2px 0px 2px 0px;"
                ></i>
              </button>
            </b-col>
            <b-col
              style="width: 70px; min-width: 70px; max-width: 70px; padding-right: 0px;padding-left: 0px;"
            ></b-col>
            <b-col
              style="flex-grow: 1; font-size: 20px; font-weight: bold;"
              class="text-center"
            >
              {{ $convert_date_string_master(this.startDate) }}
            </b-col>
            <b-col
              style="width: 70px; min-width: 70px; max-width: 70px; padding-right: 0px;padding-left: 0px;"
            >
            </b-col>
            <b-col
              style="width:80px; min-width:80px;  max-width:80px; padding-right: 0px;padding-left: 0px;"
            >
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:1px; padding-bottom:1px; background-color: #fde3c1;"
                @click.prevent="$refs.vuecal.next()"
              >
                <i
                  style="font-size: 31px !important;"
                  class="fas fa-angle-right"
                ></i>
              </button>
              <button
                class="btn-sm btn-outline-secondary border-0 float-right"
                style="padding-top:4px; padding-bottom:3px; background-color: #fde3c1; margin-right:3px;"
                @click.prevent="$refs.vuecal.switchView('month', new Date())"
              >
                <i
                  style="font-size: 25px !important;"
                  class="fas fa-map-marker-alt "
                ></i>
              </button>
            </b-col>
          </b-row>
        </div>
        <b-popover target="popover-target-1" triggers="click blur" placement="top">
          <template v-slot:title>
            Choose filter
          </template>
          <b-form-group>
            <b-form-checkbox-group
              v-model="qtake_departments_selected"
              :options="qtake_departments"
              value-field="departmentid"
              text-field="name"
              @input="change_qtake_department_selected"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </b-popover>

        <vue-cal
          ref="vuecal"
          hide-view-selector
          hide-title-bar
          :disable-views="['years', 'year']"
          today-button
          locale="en"
          :time-from="8 * 60"
          :time-to="20 * 60"
          :events="contracts"
          :time-step="30"
          @ready="viewChange"
          @view-change="viewChange"
          :active-view.sync="activeView"
          events-on-month-view="short"
        >
          <template v-slot:split-label="{ split }">
            <i class="far fa-building"></i>
            <strong>{{ split.label }}</strong>
          </template>
          <template v-slot:cell-content="{ cell }">
            <span
              class="vuecal__cell-date m-1"
              :style="{
                color:
                  cell.class == 'vuecal__cell--day6' ||
                  cell.class == 'vuecal__cell--day7'
                    ? cell.outOfScope != true
                      ? '#ffb284'
                      : '#ffb38280'
                    : '',
              }"
              ><div>
                {{ cell.content }}
              </div>
            </span>
          </template>
          <template v-slot:weekday-heading="{ heading }">
            <div
              style="font-weight:bold; width: 100%; border-radius:3px; "
              :style="change_weekdays_headings_color(heading.label)"
            >
              {{ heading.label.substring(0, 3) }}
            </div>
          </template>
          <template v-slot:no-event>{{&nbsp;}}</template>
          <template v-slot:event="{ event }">
            <div
              style="height: 60px; color: #000; border-radius: 3px; margin: 0px 5px 5px 5px;"
              :style="[
                {
                  'border-style': 'solid',
                  'border-width': '5px',
                  'background-color': event.color,
                  'border-color': event.color,
                },
              ]"
            >
              <div
                class="vuecal__event-title"
                v-html="findDepartment(event.departmentid)"
                style="color:white;font-weight: normal; font-size:15px;"
              ></div>
              <div
                class="vuecal__event-time"
                v-html="event.tieude"
                style="color:white;font-weight: normal; font-size:17px; font-weight: bold;"
              ></div>
            </div>
          </template>
        </vue-cal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MeetingSideBar from "../components/Meeting/MeetingSideBar";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/vi.js";
import "vue-cal/dist/vuecal.css";

export default {
  name: "ContractCalendar",
  components: {
    MeetingSideBar,
    VueCal,
  },
  data() {
    return {
      contracts: [],
      qtake_departments: [],
      qtake_departments_list: [],
      qtake_departments_selected: [],
      last_qtake_departments_selected: null,
      fulld_qtake_departments_selected: null,
      startDate: null,
      endDate: null,
      activeView: "month",
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.all([axios.get("/api/qtakedepartment/contract_calendar")]).then(
      axios.spread((qtake_department) => {
        next((vm) => vm.initData(qtake_department.data));
      })
    );
  },
  methods: {
    initData(qtake_departments) {
      this.qtake_departments = qtake_departments;
      this.qtake_departments_list = this.qtake_departments.slice();
      this.qtake_departments_selected = [];

      const select_all = { departmentid: -1, name: "All" };
      this.qtake_departments.unshift(select_all);

      const select_null = { departmentid: null, name: "Please select a Company..." };
      this.qtake_departments_list.unshift(select_null);

      for (let i = 0; i < qtake_departments.length; i++) {
        this.qtake_departments_selected.push(qtake_departments[i].departmentid);
      }

      this.last_qtake_departments_selected = this.qtake_departments_selected;
      this.full_qtake_departments_selected = this.qtake_departments_selected;

      this.getContract();
    },
    getContract() {
      if (this.qtake_departments_selected != null) {
        let department_id = "";
        for (let i = 0; i < this.qtake_departments_selected.length; i++) {
          if (i != 0) department_id += ",";
          department_id += this.qtake_departments_selected[i];
        }

        axios
          .get("/api/customercontract/calendar", {
            params: {
              department_id: department_id,
              start: this.startDate.getTime(),
              end: this.endDate.getTime(),
            },
          })
          .then((response) => {
            this.contracts = response.data;
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },
    viewChange(obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
      this.getContract();
    },
    change_qtake_department_selected() {
      // Find out if lost -1, deselect all
      if (
        this.qtake_departments_selected.length <
          this.last_qtake_departments_selected.length &&
        this.last_qtake_departments_selected.indexOf(-1) != -1 &&
        this.qtake_departments_selected.indexOf(-1) == -1
      ) {
        this.qtake_departments_selected = [];
      } // Find out if gain -1, select all
      else if (
        this.qtake_departments_selected.length >
          this.last_qtake_departments_selected.length &&
        this.qtake_departments_selected[
          this.qtake_departments_selected.length - 1
        ] == -1
      ) {
        this.qtake_departments_selected = this.full_qtake_departments_selected;
      }

      this.getContract();
      this.last_qtake_departments_selected = this.qtake_departments_selected;
    },
    findDepartment(id) {
      const temp = this.qtake_departments.find(function(el) {
        if (el.departmentid == id) return el;
      });
      return temp == null ? "" : temp.name;
    },
    change_weekdays_headings_color(day_name) {
      if (day_name == "Sunday" || day_name == "Saturday") {
        return { "background-color": "#ffb284" };
      } else {
        return { "background-color": "#ffd18b" };
      }
    },
  },
};
</script>

<style>
#shooting_schedule_fulid.container-fluid {
  height: calc(101% - 40px);
}
</style>
